export enum SpinSize {
    Large = 'large',
    Small = 'small',
    Default = 'default'
}
